import { toast } from "vue3-toastify";
import api from "./services/api";
import "vue3-toastify/dist/index.css";

const toastOptions = {
  autoClose: 2500,
  theme: "dark",
  style: {
    fontSize: "15px",
  },
  position: toast.POSITION.BOTTOM_RIGHT,
  hideProgressBar: true,
  closeButton: null,
};

const HttpErrorPlugin = {
  install(app, { i18n, store }) {
    let user = store.state.auth.user.email;
    let localeMessage = i18n.global.messages[i18n.global.locale];
    app.config.globalProperties.$httpError = (error, callee) => {
      if (error?.response?.status !== 401) {
        toast.warn(
          localeMessage.errorMessage.errorMessage || "An error occurred",
          toastOptions
        );
        if (!window.location.href.includes("localhost")) {
          api().post(
            "/report-error",
            JSON.stringify({ error: error, callee: callee, user: user })
          );
        }
      }
    };
  },
};

export default HttpErrorPlugin;
